export default __webpack_public_path__ + "static/Configurations 2 – 800x400-55e49595816b69cfa2b95a2846afc065.png";